import React from "react";
import { useTranslation } from "react-i18next";
import { ApexOptions } from "apexcharts";
import { Card, Col, Row } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";
import LoadingSpinner from "./LoadingSpinner";
import { GraphData } from "../List";

const GraphsTab = ({ data }: { data: GraphData | null }) => {
  const { t } = useTranslation();

  if (!data) return <LoadingSpinner />;

  const lineOptions: ApexOptions = {
    chart: {
      type: "line",
      toolbar: { show: true },
      zoom: { enabled: true },
    },
    stroke: { curve: "smooth", width: 2 },
    xaxis: {
      categories: data.categories,
      labels: { rotate: -45, style: { fontSize: "11px" } },
    },
    yaxis: { min: 0, labels: { formatter: (v) => Math.floor(v).toString() } },
    legend: { position: "top" },
    tooltip: { x: { format: "yyyy-MM-dd" } },
    colors: ["#4680ff", "#2ca87f", "#e58a00", "#dc2626", "#7c3aed", "#0891b2"],
    markers: { size: 3 },
    grid: { borderColor: "#e0e0e0" },
  };

  const areaOptions: ApexOptions = {
    ...lineOptions,
    chart: { ...lineOptions.chart, type: "area" },
    fill: { type: "gradient", gradient: { opacityFrom: 0.4, opacityTo: 0.05 } },
  };

  return (
    <Row className="g-4">
      <Col xl={12}>
        <Card>
          <Card.Header>
            <h6 className="mb-0">
              {t("statistics.dailyActivity")} - {t("statistics.last30Days")}
            </h6>
          </Card.Header>
          <Card.Body>
            <ReactApexChart
              options={areaOptions}
              series={data.series}
              type="area"
              height={380}
            />
          </Card.Body>
        </Card>
      </Col>
      <Col xl={12}>
        <Card>
          <Card.Header>
            <h6 className="mb-0">
              {t("statistics.newRegistrations")} - {t("statistics.last30Days")}
            </h6>
          </Card.Header>
          <Card.Body>
            <ReactApexChart
              options={{
                ...lineOptions,
                chart: { ...lineOptions.chart, type: "bar", stacked: false },
                plotOptions: { bar: { horizontal: false, columnWidth: "55%" } },
              }}
              series={data.series.filter((s) =>
                ["New Coaches", "New Companies", "New Jobs"].includes(s.name),
              )}
              type="bar"
              height={320}
            />
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default GraphsTab;
